import { render, staticRenderFns } from "./EditorCanvas.vue?vue&type=template&id=359e7b5b&scoped=true&"
import script from "./EditorCanvas.vue?vue&type=script&lang=js&"
export * from "./EditorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EditorCanvas.vue?vue&type=style&index=0&id=359e7b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e7b5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
